module.exports = __webpack_public_path__ + "img/advantage_02.9e15d45f.png";